import {Grid, GridProps} from '@material-ui/core'
import clsx from 'clsx'
import React, {useEffect, useRef, useState} from 'react'

import {useStickyClasses} from './classes'

const StickyGrid: React.FC<React.PropsWithChildren<GridProps>> = ({className: baseClassName, ...props}) => {
  const classes = useStickyClasses()
  const ref = useRef<HTMLDivElement>(null)
  const [isSticky, setSticky] = useState(false)
  const className = clsx(classes.root, classes.sticky, baseClassName, {
    [classes.isSticky]: isSticky,
  })

  useEffect(() => {
    const element = ref.current

    if (element) {
      const observer = new IntersectionObserver(([e]) => setSticky(e.intersectionRatio < 1), {threshold: [1]})

      observer.observe(element)

      return () => observer.unobserve(element)
    }
  }, [])

  return <Grid {...props} ref={ref} className={className} />
}

export default StickyGrid
